import MuiSnackbar, { SnackbarProps as MuiSnackbarProps } from "@mui/material/Snackbar";
import { SnackbarContent as MuiSnackbarContent, SnackbarContentProps as MuiSnackbarContentProps } from "@mui/material";
import { forwardRef } from "react";

export type ToastProps = MuiSnackbarProps;

const Toast: React.FC<ToastProps> = (props) => {
  return <MuiSnackbar {...props}>{props.children}</MuiSnackbar>;
};

export interface ToastContentProps extends Omit<MuiSnackbarContentProps, "ref"> {
  ref?: React.Ref<HTMLDivElement>;
}

export const ToastContent = forwardRef<HTMLDivElement, ToastContentProps>((props, ref) => {
  return <MuiSnackbarContent {...props} ref={ref} />;
});

ToastContent.displayName = "ToastContent";

export default Toast;
